import { z } from "zod";

import { triggerCaseSchema } from "../../nodeDesigns/triggerDesignsStateSchema.ts";
import { triggerConditionBuildSchema } from "../../shared/triggers.ts";

export const addTriggerActionSchema = z.object({
  type: z.literal("ADD_TRIGGER"),
  payload: z.object({
    nodeId: z.number().int(),
    id: z.number().int(),
    label: z.string().optional(),
    cases: z.array(triggerCaseSchema).min(1),
  }),
});

export type AddTriggerAction = z.infer<typeof addTriggerActionSchema>;

export const removeTriggerActionSchema = z.object({
  type: z.literal("REMOVE_TRIGGER"),
  payload: z.object({
    id: z.number().int(),
  }),
});

export type RemoveTriggerAction = z.infer<typeof removeTriggerActionSchema>;

export const removeAllTriggersActionSchema = z.object({
  type: z.literal("REMOVE_ALL_TRIGGERS"),
  payload: z.object({
    nodeId: z.number().int(),
  }),
});

export type RemoveAllTriggersAction = z.infer<typeof removeAllTriggersActionSchema>;

export const updateTriggerActionSchema = z.object({
  type: z.literal("UPDATE_TRIGGER"),
  payload: z.object({
    id: z.number().int(),
    label: z.string().optional(),
    cases: z.array(triggerCaseSchema).min(1).optional(),
  }),
});

export type UpdateTriggerAction = z.infer<typeof updateTriggerActionSchema>;

export const reorderTriggerActionSchema = z.object({
  type: z.literal("REORDER_TRIGGER"),
  payload: z.object({
    id: z.number().int(),
    newIndex: z.number().int().nonnegative(),
  }),
});

export type ReorderTriggerAction = z.infer<typeof reorderTriggerActionSchema>;

export const addTriggerCaseActionSchema = z.object({
  type: z.literal("ADD_TRIGGER_CASE"),
  payload: z.object({
    id: z.number().int(),
    eventType: z.string(),
    where: triggerConditionBuildSchema.optional(),
  }),
});

export type AddTriggerCaseAction = z.infer<typeof addTriggerCaseActionSchema>;

export const updateTriggerCaseActionSchema = z.object({
  type: z.literal("UPDATE_TRIGGER_CASE"),
  payload: z.object({
    id: z.number().int(),
    index: z.number().int().nonnegative(),
    eventType: z.string().optional(),
    where: triggerConditionBuildSchema.optional(),
  }),
});

export type UpdateTriggerCaseAction = z.infer<typeof updateTriggerCaseActionSchema>;

export const removeTriggerCaseActionSchema = z.object({
  type: z.literal("REMOVE_TRIGGER_CASE"),
  payload: z.object({
    id: z.number().int(),
    index: z.number().int().nonnegative(),
  }),
});

export type RemoveTriggerCaseAction = z.infer<typeof removeTriggerCaseActionSchema>;
